module.exports = __webpack_public_path__ + "img/shobe1.f521ba5d.jpg";